import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MeteorologyObservations, MeteorologyForecast } from './meteorologi.types';
import { Observable } from 'rxjs';

type Period = string; // YYYYMM or YYYYMMDD
type Resolution = "Y" | "M" | "D" | "H"; // default H for period=yyyymmdd, D for period=yyyymm

@Injectable({
  providedIn: 'root'
})
export class MeteorologiService {
  hostUrl = 'https://appgw.prod.iktest.co/api-app/chemx/metoc';

  constructor(private _httpClient: HttpClient) { }

  getObservations(objectId: string, period: Period, resolution?: Resolution): Observable<MeteorologyObservations> {
    return this._httpClient.get<MeteorologyObservations>(
      `${this.hostUrl}/observations/${objectId}/${period}${resolution ? `/${resolution}` : ''}`
    );
  }

  getForecast(objectId: string, resolution?: Resolution): Observable<MeteorologyForecast> {
    return this._httpClient.get<MeteorologyForecast>(
      `${this.hostUrl}/forecast/${objectId}${resolution ? `/${resolution}` : ''}`
    );
  }
}
